export default __webpack_public_path__ + "static/media/mozart10.1bf5559a.png";